import { Link } from 'react-router-dom';

export default function HelpLink({ id, className }) {
  return (
    <Link to={`/help#${id}`} className={`help-link ${className || ''}`} title="What is this?">
      ?
    </Link>
  );
}
